const icon = require('vue-svgicon');
icon.register({
    'chevron-right': {
        width: 28,
        height: 28,
        viewBox: '0 0 28 28',
        data: `<path pid="0" d="M6.513 24.757L18.263 14 6.512 3.244a.988.988 0 010-1.399.991.991 0 011.4 0l12.395 11.349c.05.034.118.021.162.066a.98.98 0 01.283.737.977.977 0 01-.281.744c-.047.046-.117.034-.17.07L7.912 26.157a.994.994 0 01-1.4 0 .988.988 0 010-1.399z"/>`,
    },
});
